import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { NgxMasonryOptions } from "ngx-masonry";
import { distinctUntilChanged } from "rxjs/operators";

import { UnitSharedService } from "@Unit/shared/services/unitshared.service";

import { MenuSection } from "../../Types/menu.interface";
import { MenuSectionSelectable } from "../types/menu-section-selectable.interface";

@Component({
  selector: "app-desktop-menu-all-options",
  templateUrl: "./desktop-menu-all-options.component.html",
  styleUrls: ["./desktop-menu-all-options.component.scss"],
})
export class DesktopMenuAllOptionsComponent implements OnInit {
  @Input() public menuSections: MenuSection[] = [];
  @Output() public hide = new EventEmitter<MouseEvent>();

  public masonryOptions: NgxMasonryOptions = {
    animations: {},
    columnWidth: ".grid-sizer",
  };

  public filteredSections: MenuSectionSelectable[] = [];

  public searchControl = new UntypedFormControl();
  public isUnitPortalStyle: boolean = false;

  constructor(private readonly unitSharedService: UnitSharedService) {
    this.unitSharedService.isUnitPortalStyle$.subscribe((isUnit) => {
      this.isUnitPortalStyle = isUnit;
    });
  }

  public ngOnInit(): void {
    this.filterSections("");
    this.searchControl.valueChanges.pipe(distinctUntilChanged()).subscribe((searchText) => {
      this.filterSections(searchText);
    });
  }

  private filterSections(searchText: string): void {
    this.filteredSections = this.menuSections?.map((sectionChild) => {
      const validSectionChilds: MenuSectionSelectable[] = sectionChild.childs.map((child) => {
        const sectionIsInclude = this.checkIfSectionIncludes(child.name, searchText);
        return { ...child, selected: sectionIsInclude };
      });

      return {
        ...sectionChild,
        childs: validSectionChilds,
        selected: validSectionChilds.some(({ selected }) => selected),
      };
    });
  }

  private checkIfSectionIncludes(sectionName: string, searchText: string): boolean {
    return sectionName.toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
  }

  public onClickHide(event: MouseEvent): void {
    this.hide.emit(event);
  }
}
